
// import counterReducer from '../screens/counter/counterReducer';
// import counterSage from '../screens/counter/sagas';
// import { injectReducer, injectSaga } from './rootReducer';
const injectReducers = (store) => {
	// injectReducer(store, { key: 'counter', reducer: counterReducer });
	// injectSaga(store, { key: 'counter', saga: counterSage });
};

export default injectReducers;